import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { TableColumn } from "../../../../shared/models/table-column";
import { InrRequest, InrAttachment } from "../../../../shared/models/inr-patient-profile.model";
import { APP_CONFIG } from "../../../../../environments/configurations/configurations";
import { INRService } from "../../../../shared/services/inr.service";

@Component({
  selector: 'app-inr-patient-reports',
  templateUrl: './inr-patient-reports.component.html',
  styleUrls: ['./inr-patient-reports.component.css']
})
export class InrPatientReportsComponent implements OnChanges {
  @Input() inrSet: InrRequest[] = [];
  @Output() onSelectionChange = new EventEmitter<InrRequest>();
  @Input() selectedRequest: InrRequest | null = null;
  @Input() nationalId: string = '';

  loading: boolean = false;
  APP_CONFIG = APP_CONFIG;
  patientNotes: string = "";
  openDialog: boolean = false;
  columns: TableColumn[] = [
    { field: 'submissionDate', title: 'Submission Date' },
    { field: 'submittedValue', title: 'INR Value' },
    { field: 'currentDose', title: 'Current Dose' },
    { field: 'attachments', title: 'Attachments' },
  ];

  constructor(private inrService: INRService) { }

  /**
   * Sort inrSet by id descending when input changes (Issue 7)
   * Using id instead of submissionDate to handle duplicate dates until backend updates to datetime
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['inrSet'] && this.inrSet?.length > 0) {
      this.inrSet = [...this.inrSet].sort((a, b) => {
        return b.id - a.id; // Descending order by id (newest first)
      });
    }
  }

  onRowSelect(event: any) {
    this.onSelectionChange.emit(event.data);
  }

  downloadAttachment(attachment: InrAttachment, request: InrRequest) {
    if (!this.nationalId) {
      console.error('National ID is missing');
      return;
    }
    const fileName = `${attachment.fileName}.${attachment.fileType.toLowerCase()}`;
    this.inrService.downloadDocument(this.nationalId, request.id, fileName).subscribe((data: Blob) => {
      let fileType = "";
      switch (attachment.fileType.toLowerCase()) {
        case "pdf":
          fileType = "application/pdf";
          break;
        case "doc":
          fileType = "application/msword";
          break;
        case "docx":
          fileType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
          break;
        case "png":
          fileType = "image/png";
          break;
        case "jpg":
          fileType = "image/jpeg";
          break;
        case "jpeg":
          fileType = "image/jpeg";
          break;
        case "jpeg2":
          fileType = "image/jpeg";
          break;
      }

      const blob = new Blob([data], {
        type: fileType,
      });
      const url = window.URL.createObjectURL(blob);
      window.open(url, '_blank');
    }, (error: any) => {
      console.error('Download failed', error);
    });
  }
}
